var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoNotificationFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_notification_footer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 51,
    viewBox: "0 0 47 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_564",
    "data-name": "Trac\\xE9 564",
    d: "M46.691,45.457H8.308a4.3,4.3,0,0,1-4.087-2.91,4.225,4.225,0,0,1,1.5-4.75l1.935-1.434a3.459,3.459,0,0,0,1.363-2.22L11.45,19.587a16.272,16.272,0,0,1,32.1.013l2.426,14.545a3.459,3.459,0,0,0,1.363,2.22L49.275,37.8a4.225,4.225,0,0,1,1.5,4.75,4.3,4.3,0,0,1-4.088,2.909ZM27.5,8.321a13.763,13.763,0,0,0-13.73,11.631l-2.43,14.57a5.767,5.767,0,0,1-2.272,3.7L7.134,39.655a1.92,1.92,0,0,0-.683,2.159,1.956,1.956,0,0,0,1.858,1.322H46.691a1.956,1.956,0,0,0,1.858-1.322,1.92,1.92,0,0,0-.683-2.159L45.93,38.221a5.767,5.767,0,0,1-2.272-3.7L41.23,19.965A13.764,13.764,0,0,0,27.5,8.321Z",
    transform: "translate(-4 -1.383)",
    fill: "#2b2b2b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_565",
    "data-name": "Trac\\xE9 565",
    d: "M28.08,9.341a1.154,1.154,0,0,1-1.154-1.154V6.617a2.309,2.309,0,1,0-4.617,0v1.57a1.154,1.154,0,0,1-2.309,0V6.617a4.617,4.617,0,1,1,9.234,0v1.57A1.154,1.154,0,0,1,28.08,9.341Z",
    transform: "translate(-1.117 -2)",
    fill: "#2b2b2b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_566",
    "data-name": "Trac\\xE9 566",
    d: "M25.08,47.234A8.089,8.089,0,0,1,17,39.154a1.154,1.154,0,1,1,2.309,0,5.771,5.771,0,0,0,11.543,0,1.154,1.154,0,0,1,2.309,0A8.089,8.089,0,0,1,25.08,47.234Z",
    transform: "translate(-1.58 3.766)",
    fill: "#2b2b2b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNotificationFooter);
export default __webpack_public_path__ + "static/media/ico_notification_footer.73d2538efc875c37a0dc0ae995422127.svg";
export { ForwardRef as ReactComponent };